export default `
  search(cityId: $cityId, filters: $filters, limit: $limit) {
    totalMarkers
    paginator {
      pageNumber
      count
      itemCountPerPage
      pages
      nextPageNumber
      prevPageNumber
    }
    markers {
      id
      coord
      relevance
      instantBooking
      minimumPrice
      rentableUnits {
        id
        adId
        coord
        relevance
        instantBooking
        minimumPrice
      }
    }
    aggregators {
      id
      coord
      relevance
      instantBooking
      minimumPrice
      rentableUnits {
        id
        adId
        coord
        relevance
        instantBooking
        minimumPrice
      }
    }
    homecards(locale: $locale) {
      adId
      aptFeatures
      checked
      firstAvailableDate
      id
      isInstantBooking
      isFavorite
      isNew
      mainPhotoUrl
      monthlyPrice {
        fixedPrice
        minimumPrice
        pricesByMonth {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
        type
      }
      photoUrls {
        homecardHidpi
        homecard
      }
      reviews {
        ratingAverage
      }
      title
      type
      url
    }
  }
`;
